module.exports = __webpack_public_path__ + "img/icon-aro.7accf18e.svg";